'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import StaffsController from "./controller/staffs";
import StaffModalCreateController from "./controller/staffModalCreate";
import StaffModalSelectController from "./controller/staffModalSelect";
import CuratorMizipSelectController from "./controller/curatorMizipSelect";
import StaffTableDirective from "./directive/staffTable";
import StaffTableRowDirective from "./directive/staffTableRow";
import StaffSelectDirective from "./directive/staffSelect";
import StaffService from "./service/staff";

export default angular.module('investmentProject.staff', [])
    .controller('StaffsController', StaffsController)
    .controller('StaffModalCreateController', StaffModalCreateController)
    .controller('StaffModalSelectController', StaffModalSelectController)
    .controller('CuratorMizipSelectController', CuratorMizipSelectController)
    .directive('staffTable', StaffTableDirective)
    .directive('staffSelect', StaffSelectDirective)
    .directive('staffTableRow', StaffTableRowDirective)
    .factory('StaffService', StaffService)
    .name;
